@if (hasData) {
  <div class="relative flex w-full justify-center">
    <canvas class="w-full" #lineChart></canvas>
  </div>
} @else {
  <p class="my-0 text-center" i18n>No hay horas imputadas</p>
}
